import {
  Textarea as ChakraTextarea,
  TextareaProps as ChakraTextareaProps,
  ThemingProps,
} from '@chakra-ui/react';
import React from 'react';

import { OmitChakraProps } from '../../utils/typeUtils';

export interface TextareaProps
  extends OmitChakraProps<
    ChakraTextareaProps,
    'children' | 'disabled' | 'required' | 'isRequired' | keyof ThemingProps
  > {
  size?: 'md' | 'lg';
  variant?: 'hidden' | 'outline';
}

export const Textarea: (props: TextareaProps) => React.JSX.Element =
  ChakraTextarea;
